import { useAction, useAtom } from '@reatom/npm-react'
import { useId } from 'react'
import styled from 'styled-components'

import { DtDrawer, FadeOverflow } from '@root/shared/ui-kit'

import { exploreFilterDrawer } from '../../../atoms/reatom-explore-filter-drawer'
import { ExploreFilterForm } from '../explore-filter-form'
import { ExploreFilterHeader } from '../explore-filter-header'

import { ExploreFilterFooter } from './explore-filter-footer'

import type { ExploreFiltersAtom } from '../../../atoms'
import type { ClassNameProps } from '@root/shared/react'
import type { FormEvent } from 'react'

type Props = {} & ClassNameProps

export const ExploreFilter: React.FC<Props> = ({ className }) => {
  const [exploreFiltersDrawerState] = useAtom(
    exploreFilterDrawer.exploreFilterDrawer,
  )
  const closeExploreFiltersDrawer = useAction(exploreFilterDrawer.closeAction)

  return (
    <Root
      overlay
      className={className}
      open={exploreFiltersDrawerState !== undefined}
      onOpenChange={() => closeExploreFiltersDrawer()}
    >
      {exploreFiltersDrawerState ? (
        <ExploreFilterDrawerForm
          onClose={() => closeExploreFiltersDrawer()}
          model={exploreFiltersDrawerState}
          onSubmit={() => closeExploreFiltersDrawer()}
        />
      ) : undefined}
    </Root>
  )
}
type ExploreFilterDrawerFormProps = {
  model: ExploreFiltersAtom
  onSubmit: () => void
  onClose: () => void
}
const ExploreFilterDrawerForm = ({
  model,
  onSubmit,
  onClose,
}: ExploreFilterDrawerFormProps) => {
  const exploreFilterFormId = useId()

  const applyFilters = useAction(model.applyFilters)

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    applyFilters()
    onSubmit()
  }

  return (
    <Form id={exploreFilterFormId} onSubmit={handleSubmit}>
      <Content>
        <ExploreFilterHeader model={model} onOpenChange={() => onClose()} />
        <Overflow
          mode="always"
          variant="vertical"
          blockEnd={14}
          blockStart={14}
        >
          <ExploreFilterForm model={model} />
        </Overflow>
      </Content>
      <ExploreFilterFooter model={model} formId={exploreFilterFormId} />
    </Form>
  )
}
const Root = styled(DtDrawer)`
  background: var(--background-1);
  align-items: start;
`
const Form = styled.form`
  display: grid;
  grid-template-rows: 1fr auto;
  padding-inline: 10px;
  padding-block: calc(var(--title-bar-height) + 55px) 15px;
  height: 100%;
  overflow: auto;
`

const Overflow = styled(FadeOverflow)`
  padding: 20px 10px;
  && {
    overflow-y: auto;
  }
  display: grid;
  align-content: start;
  min-height: 0;

  padding: 10px;
`

const Content = styled.div`
  width: 360px;
  background: var(--background-2);
  border: 1px solid var(--backgroundA-3);
  border-radius: 12px;

  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
  min-height: 0;
`
